import React from "react";
import { Navigate } from "react-router-dom";
import { tokens } from "../services/api";

/**
 * A UI guard only. The server is the real boundary -- every endpoint refuses
 * a caller who is not staff -- so this exists to send somebody to the sign-in
 * page instead of a wall of failed requests.
 */
const ProtectedRoute = ({ children }) =>
  tokens.access ? children : <Navigate to="/sign-in" replace />;

export default ProtectedRoute;
